import { makeStyles } from '@cuda-networks/bds-core'

export default makeStyles(theme => ({
  closeButton: {
    position: 'absolute',
    right: 8,
    top: 8
  }
}))
